/**
 * Created by wwei on 2018-11-09.
 */
import React, { Component } from "react";
import { translate } from "react-i18next";

class ServiceConfig extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="page-container">
        <div id="container" className="col-md-12 listView">
          <h2 className="page-title">{t("A4B.SERVICE_CONFIG")}</h2>
        </div>
      </div>
    );
  }
}

export default translate()(ServiceConfig);



// WEBPACK FOOTER //
// ./src/tenantportal/a4b/serviceConfig/ServiceConfig.js